module.exports = __webpack_public_path__ + "img/1F1F1-1F1FE.a7b44b33.svg";